module.exports = __webpack_public_path__ + "img/Eventos_cancelar_evento.6842e803.svg";